import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { IoLogoWhatsapp } from "react-icons/io";
import { ImMobile } from "react-icons/im";
import { TiPhoneOutline } from "react-icons/ti";
import { headApi } from "utils/headApi";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceStyle";

const useStyles = makeStyles(invoiceStyle);

export default function ClientDetails() {
  const [partyDetails, setPartyDetails] = React.useState([]);
  const classes = useStyles();

  const search = useLocation().search;
  const clientid = new URLSearchParams(search).get("clientid");

  async function getParty() {
    const get = headApi + `/user/+${clientid}`;
    const results = await fetch(get);
    const res = await results.json();
    setPartyDetails(res);
  }

  useEffect(() => {
    getParty();
  }, []);

  return (
    <div className={classes.productPage}>
      <GridContainer className={classes.borderLine}>
        <GridItem
          md={6}
          sm={6}
          xs={6}
          className={classes.space + " " + classes.verticalLine}
        >
          <span className={classes.invoiceDetailsHead}>Billed to :-</span>
          <br />
          <span className={classes.invoicedetailCom}>
            {partyDetails && partyDetails.company
              ? partyDetails.company
              : partyDetails.firstname + " " + partyDetails.lastname}
          </span>
          <br />
          <span className={classes.invoicedetail}>
            {partyDetails.address} {partyDetails.address1}
          </span>
          <br />
          <span className={classes.invoicedetail}>
            {partyDetails.address2} {partyDetails.address3}{" "}
            {partyDetails.zipcode}
          </span>{" "}
          <br />
          <span className={classes.invoicedetail}>
            {partyDetails.city} {partyDetails.state}
          </span>
          <br />
          <span className={classes.invoicedetails}>
            {partyDetails.mobile ? <ImMobile /> : ""}{" "}
            {partyDetails && partyDetails.mobile ? partyDetails.mobile : ""}{" "}
            {partyDetails.whatsapp ? <IoLogoWhatsapp /> : ""}{" "}
            {partyDetails && partyDetails.whatsapp ? partyDetails.whatsapp : ""}
          </span>
          <br />
          <span className={classes.invoicedetail + " " + classes.gstIn}>
            {partyDetails.gstno ? "GSTIN / UIN" : "Aadhar No."} &nbsp;&nbsp;:{" "}
            {partyDetails && partyDetails.gstno
              ? partyDetails.gstno
              : partyDetails.aadharno}
          </span>
        </GridItem>
        <GridItem md={6} sm={6} xs={6} className={classes.space}>
          <span className={classes.invoiceDetailsHead}>Shipped to :-</span>
          <br />
          <span className={classes.invoicedetailCom}>
            {partyDetails && partyDetails.company
              ? partyDetails.company
              : partyDetails.firstname + " " + partyDetails.lastname}
          </span>
          <br />
          <span className={classes.invoicedetail}>
            {partyDetails.shipaddress} {partyDetails.shipaddress1}
          </span>{" "}
          <br />
          <span className={classes.invoicedetail}>
            {partyDetails.shipaddress2} {partyDetails.shipaddress3}{" "}
            {partyDetails.shipzipcode}{" "}
          </span>{" "}
          <br />
          <span className={classes.invoicedetail}>
            {partyDetails.shipcity} {partyDetails.shipstate}
          </span>
          <br />
          <span className={classes.invoicedetails}>
            {partyDetails.alternate ? <ImMobile /> : ""}{" "}
            {partyDetails && partyDetails.alternate
              ? partyDetails.alternate
              : ""}{" "}
            {partyDetails.office ? <TiPhoneOutline /> : ""}{" "}
            {partyDetails && partyDetails.office ? partyDetails.office : ""}
          </span>
          <br />
          <span className={classes.invoicedetail + " " + classes.gstIn}>
            {partyDetails.gstno ? "GSTIN / UIN :" : "Aadhar No. :"}{" "}
            {partyDetails && partyDetails.gstno
              ? partyDetails.gstno
              : partyDetails.aadharno}
          </span>
        </GridItem>
      </GridContainer>
    </div>
  );
}
